import { Component, OnInit, OnDestroy } from '@angular/core';
import { EDeliveryService } from '../../services/edelivery.service';
import { AgreementService } from '../../services/agreement.service';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'dialog-container',
  templateUrl: './dialog-container.component.html',
  styleUrls: ['./dialog-container.component.css']
})
export class DialogContainerComponent implements OnInit, OnDestroy {

    showAgreement: boolean = false;
    showEdit: boolean = false;
    showQuickEnroll: boolean = false;

    constructor(public eDeliveryService: EDeliveryService, private agreementService: AgreementService, private dialogRef: MatDialogRef<DialogContainerComponent>) {
        this.eDeliveryService.showAgreement$.subscribe(value => {
            if (value === true) {
                this.showAgreement = true;
                this.showEdit = false;
                this.showQuickEnroll = false;
            } else {
                this.showAgreement = false;
                if (this.dialogRef.id === 'edit') {
                    this.showEdit = true;
                } else if (this.dialogRef.id === 'quickEnroll') {
                    this.showQuickEnroll = true;
                }
            }
        });
        if (this.dialogRef.id === 'edit') {
            this.showEdit = true;
        } else if (dialogRef.id === 'quickEnroll') {
            this.showQuickEnroll = true;
        }
        if (this.eDeliveryService.isNXIRequest()) {
            this.agreementService.retrieveAgreement();
        }
    }
    ngOnInit() {
    }

    ngOnDestroy() {
        if (!this.eDeliveryService.preferencesSubmitted) {
            this.eDeliveryService.trackingList = [];
        }
        this.eDeliveryService.previousSettings = [];
        this.eDeliveryService.currentSettings = [];
        this.eDeliveryService.savedSettings = [];
        this.eDeliveryService.previouslyEnrolled.clear();
        this.eDeliveryService.backButtonClicked = false; // Returning it to its original state
        this.eDeliveryService.closingDialog(); // Must reset so that it shows the quick enroll component
        this.eDeliveryService.listOfAccountsChanged = [];
        this.eDeliveryService.accountsWithChangedEmails = [];
    }

}
